'use client'

import React from "react";
import { Typography, Link, Box } from "@mui/material";

import Image from 'next/image'
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";
import pkg from '@/../package.json';
import i18nConfig from '@/i18nConfig';

interface CopyrightProps {
  topMargin?: number | { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
}

export default function Copyright({ topMargin = 5 }: CopyrightProps): JSX.Element {
  const pathname = usePathname();
  const firstSegment = pathname?.split('/').filter(Boolean)[0] || '';
  const locale = i18nConfig.locales.includes(firstSegment)
    ? firstSegment
    : i18nConfig.defaultLocale;
  const localePrefix = locale === i18nConfig.defaultLocale && !i18nConfig.prefixDefault
    ? ''
    : `/${locale}`;
  const { t } = useTranslation('common');

  return (
    <Box sx={{ mt: topMargin, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <Typography
          component="div"
          variant="h6"
          color="primary"
          align="center"
        >
          {t('secure_voting')}
        </Typography>
        <Box sx={{ mt: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5 }}>
          <Link href={`${localePrefix}/guides`} component={NextLink} variant="caption">
            {t('guides')}
          </Link>
          <Link href={`${localePrefix}/about`} component={NextLink} variant="caption">
            {t('about')}
          </Link>
        </Box>
        <Typography variant="caption" sx={{ color: '#999', mt: 0.5, display: 'block' }}>
          v{pkg.version}
        </Typography>
        <Box sx={{ mt: 1 }}>
          <Image src="/secure_icon.svg" alt="Logo" width={50} height={25} priority />
        </Box>
      </Box>
  );
}
